import request from '@/utils/request'


// 查询师傅钱包列表
export function listWallet(query) {
  return request({
    url: '/master/master-wallet/list',
    method: 'get',
    params: query
  })
}

// 查询师傅钱包分页
export function pageWallet(query) {
  return request({
    url: '/master/master-wallet/page',
    method: 'get',
    params: query
  })
}

// 查询师傅钱包详细
export function getWallet(data) {
  return request({
    url: '/master/master-wallet/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅钱包
export function addWallet(data) {
  return request({
    url: '/master/master-wallet/add',
    method: 'post',
    data: data
  })
}

// 修改师傅钱包
export function updateWallet(data) {
  return request({
    url: '/master/master-wallet/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅钱包
export function delWallet(data) {
  return request({
    url: '/master/master-wallet/delete',
    method: 'post',
    data: data
  })
}
